import { __assign } from './../../../external_lib/tslib/tslib.es6.js';
import React__default from 'react';
var Alert = function (props) {
  return React__default.createElement("svg", __assign({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React__default.createElement("path", {
    d: "M12 2.25C6.61538 2.25 2.25 6.61538 2.25 12C2.25 17.3846 6.61538 21.75 12 21.75C17.3846 21.75 21.75 17.3846 21.75 12C21.75 6.61538 17.3846 2.25 12 2.25ZM10.9853 5.25H12.9412V10.6789L12.4657 14.3899H11.5883L10.9849 10.6789V5.25H10.9853ZM12.009 18.375C11.3692 18.375 10.9305 17.7716 10.9305 17.0588C10.9305 16.3095 11.3692 15.7245 12.009 15.7245C12.5209 15.7245 13.0695 16.3095 13.0695 17.0588C13.0695 17.7716 12.5209 18.375 12.009 18.375Z",
    fill: "currentColor"
  }));
};
export { Alert as default };
//# sourceMappingURL=Alert.js.map
